<!-- Ensure you have imported ng-bootstrap and bootstrap in your Angular project -->
<div class="container mt-3">
  <div class="d-flex gap-2 align-items-start w-100">

    <!-- Dashboard navigation buttons -->
    <section class="dashboard-buttons"
    >
      <ng-container *ngFor="let button of dashboardButtons">
        <app-dashboard-button
          [buttonClass]="button.buttonClass"
          [icon]="button.icon"
          [label]="button.label"
          [linkTarget]="button.linkTarget"
          [spacingClass]="button.spacingClass!"
        ></app-dashboard-button>
      </ng-container>
    </section>

    <!-- active escalations -->
    <section *ngIf="userService.userrole() !== Userrole.Mitarbeiter" class="active-escalations">
      <app-report-card [heading]="sectionHeading">
        <div>
          <app-report-table
            [tableWidth]="'w-100'"
            [dataSource]="dashboardData.escalatedReports()"
            [displayAll]="true"
            [tableHeading]="'Eskalationen: ' + dashboardData.escalatedReports().length"
            [tableHeadingClass]="'text-qundis-warn qundis-ubuntu-32'"
            [tableSubHeading]="'Achtung diese Stillstände können nicht vom Team behoben werden und benötigen Aufmerksamkeit!'"
            [displayedColumns]='["id", "time", "reason"]'
          ></app-report-table>
        </div>
      </app-report-card>
    </section>
  </div>

  <section class="mt-4">
    <!--  search filter bar -->
    <app-search-filter-bar
        #searchFilterBar
        [useBackNavigation]="false"
        [useSearchBar]="true"
        [useFilter]="true"
        [isDashboard]="true"
        (toggleFilterEvent)="onFilterToggle()"
        (valueChange)="onValueChange($event)"
        (startSearch)="triggerSearch()"
    />
  </section>


  <!-- active and solved reports -->
  <div class="row mt-3">
    <app-report-card
      [heading]="sectionHeading"
      cardClass="mat-elevation-z8"
    >
      <section class="standstill-overview"
               *ngIf="!(searchFilterProperty())
               ; else searchFilterResults">
        <div
          class="active-reports mt-4"
          *ngIf="dashboardData.activeReports(); else noActiveReports"
        >
          <app-report-table
            [tableHeading]="'Aktive Stillstandsmeldungen'"
            [tableHeadingClass]="'qundis-ubuntu-32'"
            [displayAll]="true"
            [dataSource]="dashboardData.activeReports()!"
            [displayedColumns]="displayedColumns"
          ></app-report-table>
        </div>
        <div
          class="solved-reports mt-5"
          *ngIf="dashboardData.solvedReports(); else noReports"
        >
          <app-report-table
            [tableHeading]="'Abgeschlossene Stillstandsmeldungen'"
            [tableHeadingClass]="'qundis-ubuntu-32'"
            [dataSource]="dashboardData.solvedReports()!"
            [displayedColumns]='["id","time","reason"]'
          ></app-report-table>
        </div>
      </section>
    </app-report-card>
  </div>
</div>


<ng-template #searchFilterResults>
  <div class="d-flex flex-row justify-content-between my-3"
       *ngIf="searchFilterProperty() === 'report'; else knowledgeBaseSearch">
    <section class="result-section col-7">
      <app-workplace-card
        [workplace]="{
            reports: solvedReports(),
            activeReports: activeReports(),
            escalatedReports: escalatedReports()
            }"
        [displayProperties]="['activeReports', 'reports']"
        [totalPages]="totalPages()"
        [tableWidth]="'w-100'"
        [pagination]="true"
        (emitPageChange)="this.setPage({page: $event.page, tableType: $event.tableType})"

      />
    </section>
    <section class="filter-interface-section col-5">
      <app-filter-interface
        (closeFilterInterface)="searchFilterProperty.set(null)"
        (filterValueChange)="onFilterValueChange($event)"
      />
    </section>
  </div>
</ng-template>

<ng-template #knowledgeBaseSearch>
  <app-kd-search-results/>
</ng-template>

<ng-template #noReports>
  <div class="mt-3">Keine Stillstandsmeldungen gefunden</div>
</ng-template>
<ng-template #noActiveReports>
  <div class="mt-3">Es gibt keine aktiven Stillstände</div>
</ng-template>
